var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ActionIcon, Badge, Box, Flex, Select, Stack, Text, TextInput, Tooltip } from "@mantine/core";
import { useState } from "react";
import { CheckIcon, ArrowUUpLeftIcon } from '@phosphor-icons/react';
import { useNavigate, useParams } from "react-router";
import { useForm } from "@mantine/form";
import { parseSymfonyValidationErrors } from "../../../helpers/ErrorHelper";
import { getCategoryOptions, getColourForCategory } from "../../../helpers/CategoryHelper";
export default function WordCardEditView(_a) {
    var _this = this;
    var card = _a.card, onSaveEdit = _a.onSaveEdit, onCancelEdit = _a.onCancelEdit;
    var params = useParams();
    var navigate = useNavigate();
    var _b = useState(null), serverError = _b[0], setServerError = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var form = useForm({
        mode: 'controlled',
        initialValues: {
            word: card.word,
            pronunciation: card.pronunciation || '',
            category: card.category || '',
        },
    });
    var handleSubmit = function (values) { return __awaiter(_this, void 0, void 0, function () {
        var url, response, data, err_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (card.uuid !== '' && card.pronunciation === values.pronunciation) {
                        onCancelEdit();
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, 8, 9]);
                    url = card.uuid === ''
                        ? '/api/child/' + params.id + '/speech-item/new'
                        : '/api/speech-item/' + card.uuid;
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                            },
                            body: JSON.stringify(values),
                        })];
                case 2:
                    response = _a.sent();
                    data = null;
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, response.json()];
                case 4:
                    data = _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    err_1 = _a.sent();
                    return [3 /*break*/, 6];
                case 6:
                    switch (response.status) {
                        case 200:
                            onSaveEdit({
                                uuid: (data === null || data === void 0 ? void 0 : data.uuid) || card.uuid,
                                word: values.word,
                                pronunciation: values.pronunciation,
                                category: values.category,
                            });
                            break;
                        case 422:
                            form.setErrors(parseSymfonyValidationErrors(data));
                            break;
                        case 401:
                            navigate('/login');
                            break;
                        default:
                            setServerError('Something went wrong. Please try again.');
                    }
                    return [3 /*break*/, 9];
                case 7:
                    error_1 = _a.sent();
                    setServerError('Network error. Please check your connection.');
                    return [3 /*break*/, 9];
                case 8:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    return _jsx(_Fragment, { children: _jsxs("form", { onSubmit: form.onSubmit(handleSubmit), children: [_jsx(Box, { my: "xs", children: _jsxs(Stack, { gap: "xs", children: [card.uuid === '' ? (_jsx(TextInput, __assign({ label: "Word (or phrase)", size: "xs", placeholder: "Enter word...", autoFocus: true }, form.getInputProps('word')))) : (_jsx(Text, { fw: 700, size: "lg", style: { fontFamily: "'Fredoka', var(--mantine-font-family), sans-serif" }, children: card.word })), _jsx(TextInput, __assign({ label: "Pronunciation", size: "xs", placeholder: "Enter pronunciation...", autoFocus: card.uuid !== '' }, form.getInputProps('pronunciation'))), card.uuid === '' ? (_jsx(Select, __assign({ label: "Category", placeholder: "Choose...", data: getCategoryOptions(), style: { flex: 1 }, searchable: true, clearable: true }, form.getInputProps('category')))) : (card.category && card.category !== '' &&
                                _jsx(Badge, { color: getColourForCategory(card.category), children: card.category }))] }) }), _jsxs(Flex, { justify: "flex-start", align: "center", gap: "xs", children: [_jsx(Tooltip, { label: "Save changes", children: _jsx(ActionIcon, { variant: "filled", color: "green", size: "sm", type: "submit", "aria-label": "Save changes", children: _jsx(CheckIcon, { size: 14, weight: "bold" }) }) }), _jsx(Tooltip, { label: "Cancel edit", children: _jsx(ActionIcon, { variant: "subtle", color: "red", size: "sm", onClick: onCancelEdit, "aria-label": "Cancel edit", children: _jsx(ArrowUUpLeftIcon, { size: 14, weight: "bold" }) }) })] })] }) });
}
